import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
export const RegulatoryQualityControlReportID = 14
const mapParams = (params: RegulatoryQualityControlReportParams) => {
  return {
    ReportID: RegulatoryQualityControlReportID,
    DOTQCReportOption: params.DOTQCReportOption,
    AccountTypeID: params.AccountTypeID,
    CompanyIds: params.CompanyIds || [],
    RegulatoryModeIds: params.RegulatoryModeIds || [],
    DateRange: params.DateRange,
    DateType: params.DateType,
    DateFrom: params.DateFrom,
    DateTo: params.DateTo,
  }
}

export interface RegulatoryQualityControlReportParams {
  ReportID: number,
  DOTQCReportOption: DOTQCReportOption
  AccountTypeID: number,
  CompanyIds: number[],
  RegulatoryModeIds: number[],
  DateRange: string,
  DateType: string,
  DateFrom: string,
  DateTo: string,
}
export enum DOTQCReportOption {
  PersWithRegModeWithoutEmplCateg = 1,
  PersWithoutRegModeWithRegTests = 2,
  RegulPersNotAssociatedWithRegulPool = 3,
  RegulPersAssociatedWithMoreThanOneRegulPool = 4,
  LabRegulTestsMissingRegModeOrCategory = 5,
  TestsNotMarkedRegulatedForPersWithRegMode = 6,
  RegRandomTestsNotCreatedRARandom = 7,
  RegTestWithoutMROResult = 8

}

export function RegulatoryQualityControlReportGetCsv(params: RegulatoryQualityControlReportParams): Observable<string> {
  const requestBody: string = JSON.stringify(mapParams(params))
  return ObservableFromFetch<string>("WorkforceTrack/ExportTrackRecord", requestBody)
}

export default function RegulatoryQualityControlReportPdf(params: RegulatoryQualityControlReportParams): Observable<string> {
  const requestBody: string = JSON.stringify(mapParams(params))
  return ObservableFromFetch<string>("WorkforceReport/RegulatoryQualityControlReport", requestBody)
}
